<div class="tabs-container">
	<ng-container *ngFor="let templateReference of templateReferences; let i = index">
		<div class="tab" #tabs [ngClass]="{ 'selected-tab': i === selectedTab }" (click)="onClick(i)">
			<ng-container *ngTemplateOutlet="templateReference; context: templatesContexts[i]"></ng-container>
		</div>
		<div class="empty-border" *ngIf="i !== templateReferences.length - 1"></div>
	</ng-container>
</div>
